export default __webpack_public_path__ + "static/media/Assunto.65964c60.png";